import React from 'react';
import { stashContent } from '../rich-content/stash-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const StashDetailPage = () => {
  return <AutomaticPageBuilder content={stashContent} />;
};

export default StashDetailPage;